<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Ændre opkrævningsinterval</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Opkrævningsinterval</mat-label>
        <input matInput type="number" formControlName="opkraevningsinterval" />
        <span matSuffix>mdr.</span>
      </mat-form-field>
      @if ((opkraevningsinterval.errors && opkraevningsinterval.hasError('max')) || opkraevningsinterval.hasError('min')) {
        <mat-error>
          Opkrævningsintervallet skal være mellem {{ minOpkastningsinterval }} og {{ maxOpkastningsinterval }} mdr.
        </mat-error>
      }
      @for (error of validationErrors; track error) {
        <mat-error>{{ error }}</mat-error>
      }
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
  <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
</div>
